module.exports = __webpack_public_path__ + "static/media/Maf_banners-compliance.fdc002b2.jpg";